import React from "react";
import { Button, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { Localize } from "components/service";

const DocumentPdfField = ({ id, value, onChange, onInvalid, disabled, hasDocument }) => {
  const removeFileText = Localize({ children: "APP_SETTINGS.Remove_SelectedPdf" }).props.children;
  const fileList = value ? [{
    uid: value.uid || value.name,
    name: value.name,
    originFileObj: value,
  }] : [];

  return (
    <Upload
      id={id}
      accept=".pdf,application/pdf"
      className="file-upload"
      disabled={disabled}
      multiple={false}
      maxCount={1}
      fileList={fileList}
      locale={{ removeFile: removeFileText }}
      beforeUpload={(file) => {
        const validName = /\.pdf$/i.test(file.name);
        const validType = !file.type || file.type.toLowerCase() === "application/pdf";
        if (!validName || !validType) {
          onInvalid();
          return false;
        }
        onChange(file);
        return false;
      }}
      onRemove={() => {
        onChange(undefined);
        return true;
      }}
    >
      <Button size="small" disabled={disabled} icon={<UploadOutlined />}>
        <Localize>{hasDocument ? "APP_SETTINGS.Replace_Pdf" : "APP_SETTINGS.Select_Pdf"}</Localize>
      </Button>
    </Upload>
  );
};

export default DocumentPdfField;
